import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import type React from "react"
import { NWSS_EVENT_DETECTIONS_LABEL } from "./nwssDisplayFormat"
import { precomputedToggleGroupSx } from "./precomputedDrawerStyles"

export type NwssHistoricViewFilter = "all" | "event"

export interface NwssHistoricViewFilterToggleProps {
  value: NwssHistoricViewFilter
  onChange: (value: NwssHistoricViewFilter) => void
}

/** Filter county-level (or raw) views to event-member samples while global scope stays Historic. */
export const NwssHistoricViewFilterToggle: React.FC<
  NwssHistoricViewFilterToggleProps
> = ({ value, onChange }) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_event, next: NwssHistoricViewFilter | null) => {
      if (next != null) onChange(next)
    }}
    sx={precomputedToggleGroupSx}
  >
    <ToggleButton value="all">All</ToggleButton>
    <ToggleButton value="event" sx={{ textTransform: "none" }}>
      {NWSS_EVENT_DETECTIONS_LABEL}
    </ToggleButton>
  </ToggleButtonGroup>
)
